import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { 
  FaUserTie, 
  FaGraduationCap, 
  FaBuilding, 
  FaGlobe 
} from 'react-icons/fa';
import './Mission.css';

const Mission = () => {
  const missionDetails = [
    {
      icon: <FaUserTie size={24} />,
      title: "Experts",
      description: "Professionnels qualifiés intervenant sur des sujets spécialisés (droit, santé mentale, recrutement, entrepreneuriat...)"
    },
    {
      icon: <FaGraduationCap size={24} />,
      title: "Mentors",
      description: "Anciens étudiants étrangers diplômés, aujourd'hui professionnels, qui orientent et conseillent les nouveaux arrivants"
    },
    {
      icon: <FaBuilding size={24} />,
      title: "Entreprises partenaires",
      description: "Proposent des services aux étudiants étrangers, souvent gratuits ou à tarifs réduits"
    },
    {
      icon: <FaGlobe size={24} />,
      title: "Étudiants éligibles",
      description: "Originaires d'Afrique, Asie, Amérique, Océanie ou Antarctique. Les Européens peuvent aussi s'inscrire pour proposer leur aide"
    }
  ];

  return (
    <section className="mission-section">
      <div className="mission-container-wrapper">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="mission-container"
        >
          <h2 className="mission-title">Notre mission</h2>
          <p className="mission-text">
            La plateforme <strong>ETEF</strong> est un espace d'entraide unique où les étudiants étrangers en France peuvent accéder à des services essentiels
            et entrer en contact avec des experts, des mentors et des entreprises partenaires.
            <br /><br />
            Nous vous accompagnons dès votre arrivée en France jusqu'à l'obtention de votre premier diplôme, emploi ou votre retour au pays d'origine.
          </p>
          
          <div className="mission-details">
            <div className="mission-grid">
              {missionDetails.map((detail, index) => (
                <div key={index} className="mission-item">
                  <div className="mission-icon">
                    {detail.icon}
                  </div>
                  <div className="mission-content">
                    <h4>{detail.title}</h4>
                    <p>{detail.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="mission-cta">
            <Link to="/a-propos" className="mission-btn">
              Voir plus <FiArrowRight />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Mission;